exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ":host{display:flex;flex-direction:column}:host h3{font-weight:300;font-family:Open Sans;margin-bottom:1rem}:host .is-pressed{font-size:1.4em}:host .nommer-piece-label{color:#5a4e4e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["./~/bootstrap/scss/_functions.scss","./~/bootstrap/scss/_variables.scss","./src/main/webapp/content/scss/variables.scss"]}!./src/main/webapp/app/depot-requete/steps/justificatifs/justificatifs.component.scss
// module id = 673
// module chunks = 0